import React, { useEffect } from "react";
import { Redirect } from "react-router-dom";
import authActions from "components/Auth/actions";
import { useGoogleLogout } from "react-google-login";
import { useSelector } from "react-redux";
import { AppRouteURI } from "router/RoleBasedAccess";

const LogoutContainer = () => {
  const { loggedIn, clientId } = useSelector((state) => state.auth);
  const { logout } = authActions();
  const { signOut } = useGoogleLogout({ clientId: clientId });

  useEffect(() => {
    if (loggedIn) {
      logout();
    }
    if (clientId) {
      signOut();
    }
  }, [loggedIn, clientId, logout, signOut]);

  return <div>{!loggedIn && <Redirect to={AppRouteURI.LOGIN} />}</div>;
};

export default LogoutContainer;
